import { Typography } from '@mui/material'
import { FC } from 'react'

interface Props {
    text: string
}

const TextSplitter: FC<Props> = ({ text }) => {
    return (
        <Typography
            variant="h6"
            color="#5A5F72"
            sx={{
                mt: 1,
                mb: 1.5,
            }}>
            {text}
        </Typography>
    )
}

export default TextSplitter
